import { api } from 'helpers'
import {
  Curriculum,
  LearningExpectationsResponse,
  AnalyticalReportResponse,
  StudentDetailsRequest,
  StudentDetailsResponse,
} from './types/interfaces'

const API_ENDPOINTS = {
  GET_LEARNING_EXPECTATIONS: '/api/learning_expectations',
  GET_SUMMARY_REPORT: '/api/learning_expectations/summary_report',
  GET_ANALYTICAL_REPORT: '/api/learning_expectations/analytical_report',
  POST_STUDENT_DETAILS: '/api/learning_expectations/student_details',
}

const learningService = {
  getLearningExpectations: async (): Promise<Curriculum[]> => {
    try {
      const response = await api.get<LearningExpectationsResponse>(API_ENDPOINTS.GET_LEARNING_EXPECTATIONS)
      return response.data as unknown as Curriculum[]
    } catch (error) {
      console.error('Error fetching learning expectations:', error)
      throw error
    }
  },

  getSummaryReport: async (curriculum_id: string, cycles: string[], areas: string[]): Promise<any> => {
    const payload = { curriculum_id, cycles, areas }

    try {
      const response = await api.post(API_ENDPOINTS.GET_SUMMARY_REPORT, payload)
      return response.data as unknown as any
    } catch (error) {
      console.error('Error fetching summary report:', error)
      throw error
    }
  },

  getAnalyticalReport: async (group_id: string, areas: string[]): Promise<AnalyticalReportResponse[]> => {
    try {
      const response = await api.get(`${API_ENDPOINTS.GET_ANALYTICAL_REPORT}/${group_id}`, { params: { areas } })
      return response.data as unknown as AnalyticalReportResponse[]
    } catch (error) {
      console.error('Error fetching analytical report:', error)
      throw error
    }
  },

  getStudentDetails: async (payload: StudentDetailsRequest): Promise<StudentDetailsResponse[]> => {
    try {
      const response = await api.post(API_ENDPOINTS.POST_STUDENT_DETAILS, payload)
      return response.data as unknown as StudentDetailsResponse[]
    } catch (error) {
      console.error('Error fetching student details:', error)
      throw error
    }
  },
}

export default learningService
